import ShowBlocksCommand from "./ShowBlocksCommand";
import ShowBlocksEditing from "./ShowBlocksEditing";
import ShowBlocksUI from "./ShowBlocksUI";

import "./showBlocks.css";

import { Plugin } from "@ckeditor/ckeditor5-core";

export default class ShowBlocks extends Plugin {
  init() {
    const editor = this.editor;
  }

  static get pluginName() {
    return "ShowBlocks";
  }

  static get requires() {
    return [ShowBlocksCommand, ShowBlocksEditing, ShowBlocksUI];
  }
}
